import { UPDATE_GLOBAL_SPINNER, UPDATE_LOCAL_SPINNER } from '../../../constants/spinner.constants';
import { UpdateGlobalSpinnerAction, UpdateLocalSpinnerAction } from '../../../models/redux/actions/spinner.action';

export const updateGlobalSpinner = (isLoading: boolean): UpdateGlobalSpinnerAction => {
  return {
    type: UPDATE_GLOBAL_SPINNER,
    isLoading,
  };
};

export const updateLocalSpinner = (isLoading: boolean): UpdateLocalSpinnerAction => {
  return {
    type: UPDATE_LOCAL_SPINNER,
    isLoading,
  };
};
